export const NotesStyle = {
  Modal: 'modal',
  Sidebar: 'sidebar',
};
